import { render, staticRenderFns } from "./DefaultProjectDashboard.vue?vue&type=template&id=ea196654&scoped=true&"
import script from "./DefaultProjectDashboard.vue?vue&type=script&lang=js&"
export * from "./DefaultProjectDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DefaultProjectDashboard.vue?vue&type=style&index=0&id=ea196654&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea196654",
  null
  
)

export default component.exports